export const AI_REPORT_CTA_SECTION_TRANSLATIONS = {
    WANT_A_CUSTOMIZED_RECOMMENTATION: "ai_report_cta_section.want_a_customized_recommentation",
    BUILD_IT: "ai_report_cta_section.build_it",
    TALK_TO_US: "ai_report_cta_section.talk_to_us",
} as const;
